import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import useNotification from "./useNotification";

export interface FormData {
  standard: string;
  courseName: string;
  title: string;
  body: string;
  sendToAll: boolean;
}

const Notification = () => {
  const [formData, setFormData] = useState<FormData>({
    title: "",
    body: "",
    standard: "",
    courseName: "",
    sendToAll: false,
  });
  const [sending, setSending] = useState(false);
  const [filteredCourses, setFilteredCourses] = useState<any[]>([]);

  const { sendBrodcastNotification, fetchStandardAndCourse, courses, standard } =
    useNotification();


    useEffect(()=>{
      fetchStandardAndCourse()
    } ,[])


  useEffect(() => {
    // Update filteredCourses based on selected standard
    if (formData.standard) {
      const filtered = courses.filter(
        (course) => course.standard === formData.standard
      );
      setFilteredCourses(filtered);
    } else {
      setFilteredCourses([]);
    }
  }, [formData.standard, courses]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData({ ...formData, [name]: fieldValue });
  };

  const sendNotification = async () => {
    setSending(true);
    try {
      const response = await sendBrodcastNotification(formData);
      toast.success("Notification sent successfully!");
      console.log(response);
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Failed to send notification. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
          Send Notification
        </h1>

        {/* Checkbox for Send to All */}
        <div className="mb-4 flex items-center">
          <input
            type="checkbox"
            id="sendToAll"
            name="sendToAll"
            checked={formData.sendToAll}
            onChange={handleChange}
            className="mr-2"
          />
          <label htmlFor="sendToAll" className="text-gray-700 font-medium">
            Send to All
          </label>
        </div>

        {/* Standard Dropdown */}
        {!formData.sendToAll && (
          <div className="mb-4">
            <label htmlFor="standard" className="block text-gray-700 font-medium mb-2">
              Education
            </label>
            <select
              id="standard"
              name="standard"
              value={formData.standard}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="">Select Standard</option>
              {standard.map((std: string) => (
                <option key={std} value={std}>
                  {std}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Course Dropdown */}
        {!formData.sendToAll && (
          <div className="mb-4">
            <label htmlFor="courseName" className="block text-gray-700 font-medium mb-2">
              Stream
            </label>
            <select
              id="courseName"
              name="courseName"
              value={formData.courseName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="">Select Course</option>
              {filteredCourses.map((course) => (
                <option key={course.courseName} value={course.courseName}>
                  {course.courseName}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Title Input */}
        <div className="mb-4">
          <label htmlFor="title" className="block text-gray-700 font-medium mb-2">
            Title
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter notification title"
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        {/* Body Input */}
        <div className="mb-6">
          <label htmlFor="body" className="block text-gray-700 font-medium mb-2">
            Body
          </label>
          <textarea
            id="body"
            name="body"
            value={formData.body}
            onChange={handleChange}
            placeholder="Enter notification body"
            rows={4}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
          ></textarea>
        </div>

        {/* Submit Button */}
        <button
          onClick={sendNotification}
          disabled={sending}
          className={`w-full bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none transition ${
            sending ? "bg-blue-900" : ""
          }`}
        >
          {sending ? "Sending Notification ..." : "Send Notification"}
        </button>
      </div>
    </div>
  );
};

export default Notification;
